import AlertsService from '@/services/alerts'
import ConfirmService from '@/services/ConfirmService'
import MediaPreviewService from '@/services/MediaPreviewService'
import AuthPage from '@/pages/Auth'
import CmsAdmin from '@/features/cms'
import useAuthSession from '@/pages/Auth/useAuthSession'

const App = () => {
  const auth = useAuthSession()

  return (
    <>
      <MediaPreviewService />
      <AlertsService />
      <ConfirmService />
      {auth.session ? <CmsAdmin auth={auth} /> : <AuthPage auth={auth} />}
    </>
  )
}

export default App
